import SuccessOrderPageBody from '../../../components/SuccessOrderPage/SuccessOrderPageBody';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(SuccessOrderPageBody);
